"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormsAuthenticationService = void 0;
const tslib_1 = require("tslib");
const client_utils_1 = require("@sensenet/client-utils");
const semaphore_async_await_1 = tslib_1.__importDefault(require("semaphore-async-await"));
const __1 = require("..");
/**
 * Authentication Service class for using Forms authentication through OData Actions
 */
class FormsAuthenticationService {
    constructor(repository, userLoadOptions = { select: 'all' }) {
        this.repository = repository;
        this.userLoadOptions = userLoadOptions;
        this.statusLock = new semaphore_async_await_1.default(1);
        /**
         * This observable indicates the current state of the service
         * @default LoginState.Pending
         */
        this.state = new client_utils_1.ObservableValue(__1.LoginState.Unknown);
        /**
         * Observable value that will update with the current user on user change
         */
        this.currentUser = new client_utils_1.ObservableValue(__1.ConstantContent.VISITOR_USER);
        this.repository.authentication = this;
    }
    /**
     * Static Factory Method for attaching the service to a Repository object
     * @param repository The repository instance
     * @param loadUserOptions Additional options for loading User content
     */
    static Setup(repository, loadUserOptions) {
        const service = new FormsAuthenticationService(repository, loadUserOptions);
        service.getCurrentUser();
        return service;
    }
    /**
     * Disposes the service, the state and currentUser observables
     */
    dispose() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.state.dispose();
            this.currentUser.dispose();
        });
    }
    /**
     * Placehlolder to check if a token update is needed. Not used with Forms authentication
     */
    checkForUpdate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    /**
     * Returns the current user value
     */
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.statusLock.acquire();
                this.state.setValue(__1.LoginState.Pending);
                try {
                    const result = yield this.repository.loadCollection({
                        path: __1.ConstantContent.PORTAL_ROOT.Path,
                        oDataOptions: Object.assign(Object.assign({}, this.userLoadOptions), { query: 'Id:@@CurrentUser.Id@@', top: 1 }),
                    });
                    if (result.d.__count === 1) {
                        if (result.d.results[0].Id !== __1.ConstantContent.VISITOR_USER.Id) {
                            this.state.setValue(__1.LoginState.Authenticated);
                            this.currentUser.setValue(result.d.results[0]);
                            return result.d.results[0];
                        }
                    }
                }
                catch (_a) {
                    /** */
                }
                this.state.setValue(__1.LoginState.Unauthenticated);
                this.currentUser.setValue(__1.ConstantContent.VISITOR_USER);
                return __1.ConstantContent.VISITOR_USER;
            }
            finally {
                yield this.statusLock.release();
            }
        });
    }
    /**
     * Logs in with the provided credentials
     * @param username The username for the login
     * @param password The password for the login
     */
    login(username, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.statusLock.acquire();
                const user = yield this.repository.executeAction({
                    body: {
                        username,
                        password,
                    },
                    method: 'POST',
                    idOrPath: __1.ConstantContent.PORTAL_ROOT.Id,
                    name: 'Login',
                });
                this.currentUser.setValue(user.d);
                const isVisitor = user.d.Id !== __1.ConstantContent.VISITOR_USER.Id ? true : false;
                this.state.setValue(isVisitor ? __1.LoginState.Authenticated : __1.LoginState.Unauthenticated);
                return isVisitor;
            }
            catch (error) {
                return false;
            }
            finally {
                this.statusLock.release();
            }
        });
    }
    /**
     * Logs out and destroys the current session
     */
    logout() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.repository.executeAction({
                    method: 'POST',
                    idOrPath: __1.ConstantContent.PORTAL_ROOT.Id,
                    name: 'Logout',
                    body: {},
                });
            }
            catch (error) {
                // ignore json parsing errors from empty response
            }
            this.currentUser.setValue(__1.ConstantContent.VISITOR_USER);
            this.state.setValue(__1.LoginState.Unauthenticated);
            return true;
        });
    }
}
exports.FormsAuthenticationService = FormsAuthenticationService;
//# sourceMappingURL=FormsAuthenticationService.js.map